// inspectables[gameId][playerCount][stage][playerId] => string[]
export const INSPECTABLES = {
  1: { // gameId 1
    4: { // playerCount
      1: { // stage
        1: [
          "stage1player1:rackCentral",
          "stage1player1:etiquette1",
          "stage1player1:etiquette2",
          "stage1player1:cables1",
          "stage1player1:cables2",
          "stage1player1:postIt1",
          "stage1player1:origamiPaper",
        ],
        2: [
          "stage1player2:notebookMarie",
          // "stage1player2:notebookAlex",
          "stage1player2:notebookSamir",
          "stage1player2:whiteboard",
          "stage1player2:rhRegister",
          "stage1player2:postItsWall",
          "stage1player2:chair1",
          "stage1player2:chair2",
          "stage1player2:chair3",
          "stage1player2:chair4",
          "stage1player2:chair5",
        ],
        3: [
          "stage1player3:pcScreen",
          "stage1player3:notebook",
          "stage1player3:documents",
          "stage1player3:puzzle",
          "stage1player3:phone",
          "stage1player3:shapes",
          "stage1player3:postit-order"
        ],
        4: [
          // "stage1player4:bookShelf",
          "stage1player4:desk",
          "stage1player4:drawerNote",
          "stage1player4:glassBox",
          "stage1player4:dictionary",
          "stage1player4:book1",
          "stage1player4:book2",
          // "stage1player4:book3",
          // "stage1player4:book4",
          // "stage1player4:book5",
          "stage1player4:rhNote",
          "stage1player4:neonPad",
        ],
      },
      2: {
        1: [
          // Hotspots principaux (énigmes)
          "stage2player1:computer",
          "stage2player1:box",
          "stage2player1:dossierAlpha",
          "stage2player1:dossierBeta",
          "stage2player1:noteOrder",
          // Hotspot conditionnel 4J/5J (rapport [T-X] remplace Policy Simulator)
          "stage2player1:rapportTX",
          // Hotspots contextuels
          "stage2player1:postitMural",
          // "stage2player1:boiteSol",
          "stage2player1:tiroir",
          "stage2player1:serveur",
          "stage2player1:classeur",
        ],
        2: [
          // Hotspots principaux (énigmes)
          "stage2player2:whiteboard",
          "stage2player2:terminal",
          "stage2player2:neuralCircuit",
          // Laptop + éléments rapatriés de J5 (4J uniquement)
          "stage2player2:laptop",
          "stage2player2:procedure",
          "stage2player2:postitLaptop",
          // Hotspots contextuels
          "stage2player2:tableau",
          "stage2player2:livre",
          "stage2player2:feuilles",
          "stage2player2:postit",
          "stage2player2:tiroir",
        ],
        3: [
          // Hotspots principaux (énigmes) — sans stressMonitor (J6 absent en 4J)
          "stage2player3:controlPanel",
          "stage2player3:terminal",
          "stage2player3:trainingMonitor",
          // Hotspots contextuels
          "stage2player3:screenLive",
          "stage2player3:carnet",
          "stage2player3:feuilles",
          "stage2player3:tiroir",
        ],
        4: [
          // Hotspots principaux (énigmes)
          "stage2player4:badge",
          "stage2player4:computer",
          "stage2player4:trainingTerminal",
          // Hotspots contextuels
          "stage2player4:sac",
          "stage2player4:feuilles",
          "stage2player4:tiroir",
        ],
        // Pas de J5 en 4J
      },
      3: {
        1: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        2: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        3: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        4: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
      },
    },
    5: { // playerCount
      1: {
        1: [
          "stage1player1:rackCentral",
          "stage1player1:etiquette1",
          "stage1player1:etiquette2",
          "stage1player1:cables1",
          "stage1player1:cables2",
          "stage1player1:postIt1",
          "stage1player1:origamiPaper",
        ],
        2: [
          "stage1player2:notebookMarie",
          // "stage1player2:notebookAlex",
          "stage1player2:notebookSamir",
          "stage1player2:whiteboard",
          "stage1player2:rhRegister",
          "stage1player2:postItsWall",
          "stage1player2:chair1",
          "stage1player2:chair2",
          "stage1player2:chair3",
          "stage1player2:chair4",
          "stage1player2:chair5",
        ],
        3: [
          "stage1player3:pcScreen",
          "stage1player3:notebook",
          "stage1player3:documents",
          "stage1player3:puzzle",
          "stage1player3:phone",
          "stage1player3:shapes",
          "stage1player3:postit-order"
        ],
        4: [
          // "stage1player4:bookShelf",
          "stage1player4:glassBox",
          "stage1player4:dictionary",
          "stage1player4:book1",
          "stage1player4:book2",
          // "stage1player4:book3",
          // "stage1player4:book4",
          // "stage1player4:book5",
          "stage1player4:rhNote",
          "stage1player4:neonPad",
        ],
        5: [
          "stage1player5:lockedDrawer",
          "stage1player5:pcScreen",
          "stage1player5:postIt",
          "stage1player5:fakeBinder",
          "stage1player5:schema1",
          "stage1player5:schema2",
          "stage1player5:charter",
          "stage1player5:planner",
        ],
      },
      2: {
        1: [
          // Hotspots principaux (énigmes)
          "stage2player1:computer",
          "stage2player1:box",
          "stage2player1:dossierAlpha",
          "stage2player1:dossierBeta",
          "stage2player1:noteOrder",
          // Hotspot conditionnel 4J/5J (rapport [T-X] remplace Policy Simulator)
          "stage2player1:rapportTX",
          // Hotspots contextuels
          "stage2player1:postitMural",
          // "stage2player1:boiteSol",
          "stage2player1:tiroir",
          "stage2player1:serveur",
          "stage2player1:classeur",
        ],
        2: [
          // Hotspots principaux (énigmes) — identique au 6J (laptop reste chez J5 en 5J)
          "stage2player2:whiteboard",
          "stage2player2:terminal",
          "stage2player2:neuralCircuit",
          // Hotspots contextuels
          "stage2player2:tableau",
          "stage2player2:livre",
          "stage2player2:feuilles",
          "stage2player2:postit",
          "stage2player2:tiroir",
        ],
        3: [
          // Hotspots principaux (énigmes) — sans stressMonitor (J6 absent en 5J)
          "stage2player3:controlPanel",
          "stage2player3:terminal",
          "stage2player3:trainingMonitor",
          // Hotspots contextuels
          "stage2player3:screenLive",
          "stage2player3:carnet",
          "stage2player3:feuilles",
          "stage2player3:tiroir",
        ],
        4: [
          // Hotspots principaux (énigmes)
          "stage2player4:badge",
          "stage2player4:computer",
          "stage2player4:trainingTerminal",
          // Hotspots contextuels
          "stage2player4:sac",
          "stage2player4:feuilles",
          "stage2player4:tiroir",
        ],
        5: [
          // Hotspots principaux (énigmes)
          "stage2player5:planning",
          "stage2player5:notebook1",
          "stage2player5:notebook2",
          "stage2player5:postit",
          "stage2player5:portraits",
          "stage2player5:terminal",
          "stage2player5:laptop",
          // Hotspots contextuels
          "stage2player5:postits",
          "stage2player5:procedure",
          "stage2player5:carnet",
        ],
      },
      3: {
        1: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        2: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        3: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        4: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        5: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
      },
    },
    6: {
      1: {
        1: [
          "stage1player1:rackCentral",
          "stage1player1:etiquette1",
          "stage1player1:etiquette2",
          "stage1player1:cables1",
          "stage1player1:cables2",
          "stage1player1:postIt1",
          "stage1player1:origamiPaper",
        ],
        2: [
          "stage1player2:notebookMarie",
          // "stage1player2:notebookAlex",
          "stage1player2:notebookSamir",
          "stage1player2:whiteboard",
          "stage1player2:postItsWall",
          "stage1player2:chair1",
          "stage1player2:chair2",
          "stage1player2:chair3",
          "stage1player2:chair4",
          "stage1player2:chair5",
        ],
        3: [
          "stage1player3:pcScreen",
          "stage1player3:notebook",
          "stage1player3:documents",
          "stage1player3:puzzle",
          "stage1player3:phone",
          "stage1player3:shapes",
          "stage1player3:postit-order"
        ],
        4: [
          // "stage1player4:bookShelf",
          "stage1player4:glassBox",
          "stage1player4:dictionary",
          "stage1player4:book1",
          "stage1player4:book2",
          // "stage1player4:book3",
          // "stage1player4:book4",
          // "stage1player4:book5",
          "stage1player4:rhNote",
          "stage1player4:neonPad"
        ],
        5: [
          "stage1player5:lockedDrawer",
          "stage1player5:pcScreen",
          "stage1player5:postIt",
          "stage1player5:fakeBinder",
          "stage1player5:schema1",
          "stage1player5:schema2",
          "stage1player5:charter",
          "stage1player5:planner",
        ],
        6: [
          "stage1player6:registerSafe",
          "stage1player6:postIt",
          "stage1player6:dices",
          "stage1player6:charter",
          "stage1player6:drawer",
          "stage1player6:plant",
          "stage1player6:paper",
          "stage1player6:whiteboard",
          "stage1player6:deskDrawer",
        ],
      },
      2: {
        1: [
          "stage2player1:computer",
          "stage2player1:box",
          "stage2player1:dossierAlpha",
          "stage2player1:dossierBeta",
          "stage2player1:noteOrder",
          "stage2player1:postitMural",
          // "stage2player1:boiteSol",
          "stage2player1:tiroir",
          "stage2player1:serveur",
          "stage2player1:classeur",
        ],
        2: [
          "stage2player2:whiteboard",
          "stage2player2:terminal",
          "stage2player2:neuralCircuit",
          "stage2player2:tableau",
          "stage2player2:livre",
          "stage2player2:feuilles",
          "stage2player2:postit",
          "stage2player2:tiroir",
        ],
        3: [
          "stage2player3:controlPanel",
          "stage2player3:terminal",
          "stage2player3:trainingMonitor",
          "stage2player3:stressMonitor",
          "stage2player3:screenLive",
          "stage2player3:carnet",
          "stage2player3:feuilles",
          "stage2player3:tiroir",
        ],
        4: [
          "stage2player4:badge",
          "stage2player4:computer",
          "stage2player4:trainingTerminal",
          "stage2player4:sac",
          "stage2player4:feuilles",
          "stage2player4:tiroir",
        ],
        5: [
          "stage2player5:planning",
          "stage2player5:notebook1",
          "stage2player5:notebook2",
          "stage2player5:postit",
          "stage2player5:portraits",
          "stage2player5:terminal",
          "stage2player5:laptop",
          "stage2player5:postits",
          "stage2player5:procedure",
          "stage2player5:carnet",
        ],
        6: [
          "stage2player6:computer",
          "stage2player6:simulator",
          "stage2player6:books",
          "stage2player6:bottle",
          "stage2player6:clock",
          "stage2player6:sculpture",
          "stage2player6:drawers",
        ],
      },
      3: {
        1: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        2: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        3: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        4: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        5: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
        6: ["stage3player:terminal", "stage3player:door", "stage3player:server", "stage3player:computer", "stage3player:monitor"],
      },
    },
  },

  2: { /* gameId 2 ... */ },
};

export function getInspectKeys({ gameId, playerCount, stage, seat }) {
  const keys =
    INSPECTABLES?.[Number(gameId)]?.[Number(playerCount)]?.[Number(stage)]?.[Number(seat)] || [];
  console.log('debug keys', keys)
  return Array.isArray(keys) ? [...keys] : [];
}

export function getInspectableTotals({ gameId, playerCount, stage }) {
  const cfg = INSPECTABLES?.[Number(gameId)]?.[Number(playerCount)]?.[Number(stage)];
  if (!cfg) return { teamTotal: 0, bySeat: {} };

  const bySeat = {};
  let teamTotal = 0;

  Object.entries(cfg).forEach(([seat, keys]) => {
    const n = Array.isArray(keys) ? keys.length : 0;
    bySeat[Number(seat)] = n;
    teamTotal += n;
  });

  return { teamTotal, bySeat };
}